import Model from '~/models/base/Model';

/**
 * class representing Note
 * @extends Model
 */
export default class Note extends Model {
    static _url = `${Model._url}/notes/`;

    constructor(id = null) {
        super(id);
    }

    static all(params) {
        const { incidentId, ...payload } = params || {};
        payload.url = incidentId
            ? `${Model._url}/incidents/${incidentId}/notes/`
            : this._url;
        return Model.all(payload);
    }

    static get(id, params) {
        const { incidentId, ...rest } = params || {};
        const requestUrl = incidentId
            ? `${APP_URL.api}/incidents/${incidentId}/note/${id}/`
            : this._url;
        const requestPayload = { params: rest };
        return this.api.get(requestUrl, requestPayload);
    }

    /**
     * Get notes fields
     * @returns {AxiosPromise<any>}
     * @author sst
     */
    static getFields() {
        const requestUrl = `${this._url}fields/`;
        return this.api.get(requestUrl);
    }
}
